function normalizeFetchError(error) {
  if (!error || typeof error !== 'object') {
    return {
      statusCode: 500,
      statusMessage: 'Failed to load blog article'
    };
  }

  return {
    statusCode: Number(error.statusCode) || Number(error.status) || 500,
    statusMessage: String(error.statusMessage ?? error.message ?? 'Failed to load blog article')
  };
}

function buildNotFoundError() {
  return {
    statusCode: 404,
    statusMessage: 'Not Found'
  };
}

function resolveBlogDetailFetchState(input = {}) {
  const data = input.data ?? null;
  const error = input.error ?? null;

  if (error) {
    const normalizedError = normalizeFetchError(error);
    if (normalizedError.statusCode === 404) {
      return {
        shouldThrow: true,
        throwError: buildNotFoundError(),
        article: null,
        primaryCta: null,
        forceNoIndex: true
      };
    }

    return {
      shouldThrow: true,
      throwError: normalizedError,
      article: null,
      primaryCta: null,
      forceNoIndex: true
    };
  }

  if (Number(data?.statusCode) === 404) {
    return {
      shouldThrow: true,
      throwError: buildNotFoundError(),
      article: null,
      primaryCta: null,
      forceNoIndex: true
    };
  }

  const article = data?.article ?? null;
  const primaryCta = data?.primaryCtas?.[0] ?? null;
  const availableLocales = Array.isArray(data?.availableLocales)
    ? data.availableLocales.map((item) => String(item)).filter(Boolean)
    : article?.meta?.locale
      ? [String(article.meta.locale)]
      : [];

  return {
    shouldThrow: false,
    throwError: null,
    article,
    primaryCta,
    forceNoIndex: data?.forceNoIndex === true || !article,
    availableLocales
  };
}

export { resolveBlogDetailFetchState };
